import React, { useContext, useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useParams } from 'react-router-dom';
import SettlementController from '../../controller/SettlementController';
import { nanoid } from 'nanoid';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import { useNavigate } from 'react-router-dom';
import DeliveryController from '../../controller/DeliveryController';
import toast from 'react-hot-toast';
import { DELIVERY_POINTS, DELIVERY_WITHDRAW_MIN } from '../../utils/DataType';
import CheckModal from './CheckModal';

const DeliveryManRegister = (oProps: any) => {
  const [sUuid, set_sUuid] = useState<string>("");
  const [iCurrentPoints, set_iCurrentPoints] = useState<number>(0);
  const [marketingCheck, setMarketingCheck] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [visibleNumber, setVisibleNumber] = useState<boolean>(false);
  const [bSaveComplete, set_bSaveComplete] = useState<boolean>(false);
  const navigate = useNavigate();
  let oParams = useParams();

  const GlobalStyle = createGlobalStyle`
    html, body, #root, #root > div {
      height: 100%
    }
  `

  const onChange_phoneNumber = (e: any) => {
    setPhoneNumber(formatPhoneNumber(e.target.value));
  };

  const openCheckPhoneNum = () => {
    if (formatPhoneNumber(phoneNumber).length > 9) {
      setVisibleNumber(true);
    } else {
      toast.error('올바른 전화번호를 입력하세요');
    };
  };

  const formatPhoneNumber = (phoneNumber: string) => {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    let formatted = cleaned;
    if (cleaned.length === 9) formatted = cleaned.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    else if (cleaned.length === 10)
      formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    else formatted = cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    return formatted;
  };


  const getPoints = async (sUuidValue: string) => {
    try {
      const response = await DeliveryController.getDeliveryPoint(sUuidValue);

      if (response.data.ok) {
        if (response.data.data) {
          set_iCurrentPoints(response.data.data.point);

          if (response.data.data.point < DELIVERY_WITHDRAW_MIN) {
            let sOrderId = oParams.order_id;
            let sOrderSeq = oParams.order_seq;
            navigate(`/order/accumulate/${sOrderId}/${sOrderSeq}`);
          }
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  }

  const initUuid = async () => {
    let sUuid = await AsyncLocalStorage.getItem('uuid');
    if (sUuid) {
      set_sUuid(sUuid);
    } else {
      let sNewUuid = nanoid();
      await AsyncLocalStorage.setItem('uuid', sNewUuid);
      set_sUuid(sNewUuid);
    }
  }

  useEffect(() => {
    initUuid();

    return () => {
    };
  }, []);

  useEffect(() => {
    if (sUuid) {
      getPoints(sUuid);
    }

    return () => {
    };
  }, [sUuid]);

  return (
    <>
      <Style>
        <>
          <GlobalStyle />
          <div className="content">
            <img src={`${process.env.PUBLIC_URL}/img/knock_logo.png`} width="14%" alt="logo" />
            <>
              <div className="textContent">
                <h1>{DELIVERY_POINTS}포인트가{'\n'}적립되었어요{'\n'}안전운전 하세요!😄</h1>
              </div>
              <div className="spacer"></div>
              <h3>
                {`현재 보유하신 응원지원금은\n`}
                <span className={`pickupFont pointFont`}>{`${iCurrentPoints.toLocaleString()}P`}</span>{` 입니다`}
              </h3>
              <div className="footer">
                <div className="row">
                  <div className="inputContainer">
                    <h4>응원지원금 받으실 전화번호를 입력해주세요</h4>
                    <input value={phoneNumber} onChange={onChange_phoneNumber} placeholder="-없이 숫자만 입력해주세요" maxLength={13} />
                  </div>
                  <div className="checkBoxContainer" onClick={() => setMarketingCheck(!marketingCheck)}>
                    <div className={`checkBox ${marketingCheck && 'active'}`}>
                      <img src={`${process.env.PUBLIC_URL}/svg/ic_check_bold.svg`} width={14} height={14} alt="체크박스" />
                    </div>
                    <h5>마케팅 수신에 동의해주시면 노크노크 이벤트가 있을때마다 알려드려요</h5>
                  </div>
                </div>
                {bSaveComplete === false &&
                  <button className={`deliveryRemaining`} onClick={() => openCheckPhoneNum()}>
                    <h1>포인트 정산 받기</h1>
                  </button>
                }
                {bSaveComplete === true &&
                  <button className={`deliverySaveComplete`}>
                    <h1>포인트가 적립 완료</h1>
                  </button>
                }
              </div>
            </>

          </div>
        </>
      </Style>
      <CheckModal
        isVisible={visibleNumber}
        setVisible={setVisibleNumber}
        type="phone"
        uuid={sUuid}
        marketingCheck={marketingCheck}
        number={formatPhoneNumber(phoneNumber)}
        setComplete={set_bSaveComplete}
      />
    </>
  );
};
export default DeliveryManRegister;

export const Style = styled.div`
  .pickupFont {
    color: #4dd2ae;
  }
  .deliveryFont {
    color: #ff8d23;
  }
  .pointFont {
    font-size: 32px; font-weight: 700;
  }

  .content {
    position: relative;
    /*width: 100%;*/
    height: 100%;
    text-align: left;
    padding: 10px;
    background: #ffffff;
    white-space: pre-line;
    display: flex;
    flex-direction: column;
    flex:1;
  }
  .textContent {
  }
  img {
    padding-bottom:30px;
  }
  p {
    font-size: 14px;
    line-height: 14px;
    font-weight: 300;
    color: #000000;
    margin: 0;
  }
  h1 {
    font-size: 28px;
    line-height: 40px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    font-weight: 600;
    margin-bottom: 20px;
  }
  h3 {
    line-height: 30px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    margin: 0;
    font-weight: 500;
    span.delivery {
      background: #ffdcbb;
    }
    span.pickup {
      background: #d3f7ed;
    }
    span.point {
      font-size: 32px;
      line-height: 36px;
      background: none;
      font-weight: 700;
    }
  }
  .inputContainer {
    width:100%;
  }
  input {
    margin: 10px 0 2px 0;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #cecece;
    padding: 10px 12px;
    font-size: 16px;
    line-height: 22px;
    color: #555555;
    font-weight: 500;
  }
  input::placeholder {
    color: #cecece;
  }
  
  .row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex-direction: column;
    padding: 6px 0 8px 0;
    h5 {
      font-weight: 500;
      color: #a7a7a7;
      padding-left: 6px;
    }
    .checkBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border: 1px solid #a7a7a7;
      background: #ffffff;
      border-radius: 2px;
      margin-top: 3px;

      img { padding: 0; }
    }
    .checkBox.active {
      border: 1px solid #4dd2ae;
      background: #4dd2ae;
    }
    .checkBoxContainer {
      display: flex;
      flex-direction: row;
      align-items: flex-start;

    }
  }

  .spacer {
    flex:1
  }
  .gap {
    margin-top: 6%;
  }
  .footer {
    padding-top: 10px;
  }
  .box {
    background: #f6f6f6;
    border-radius: 10px;
    padding: 16px;
  }
  .box h4 {
    font-size: 16px;
    line-height: 30px;
    color: #979797;
    font-weight: 500;
    margin: 0;
  }
  button {
    margin-top: 12px;
    width: 100%;
    height: 14vh;
    background: #4dd2ae;
    border: none;
    border-radius: 5px;
    min-height: 120px;
  }
  button.delivery {
    background: #ff8d23;
  }
  button h1 {
    font-weight: 600;
    margin: 0;
    color: #ffffff;
  }
  button h3 {
    font-weight: 600;
    color: #ffffff;
  }
  button.deliverySaveComplete {
    background: #CECECE;
  }
`;
